import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  useRouteMatch, Switch, Route,
} from 'react-router-dom';
import { CallbackComponent, SignoutCallbackComponent, processSilentRenew } from 'redux-oidc';

import userManager from '../../../helpers/userManager';
import { NODE_ENV } from '../../../env';
import { logger } from '../../../utils/common';
import { Container, Title, Message } from './oidc-callback-handler.style';

/**
 * Handles the callback from OIDC authentication
 * @param {object} params - Object containing props for this component
 * @param {object} params.history - history object from the browser
 * @return {element} - Call back component
 */
const OidcCallbackHandler = ({ history }) => {
  const match = useRouteMatch();
  const renewMatch = useRouteMatch(`${match.path}/renew`);

  const onSigninSuccess = () => {
    // TODO: remove once Identity Server supports redirecting to linked URLs
    const storedLocation = sessionStorage.getItem('linkedUrl');
    sessionStorage.removeItem('linkedUrl');
    const parsedLocation = storedLocation && JSON.parse(storedLocation);

    history.replace(parsedLocation || '/');
  };

  const onSignoutSuccess = () => {
    setTimeout(onSigninSuccess, 1500);
  };

  /**
   * Handles when a user was not able to login
   * @param {object} error - Error associated to event
   */
  const onFailure = (error) => {
    if (NODE_ENV === 'development') {
      logger.error(error);
    }
    history.push('/');
  };

  useEffect(() => {
    if (renewMatch) {
      processSilentRenew();
    }
  }, [renewMatch]);

  return (
    <Switch>
      <Route exact path={`${match.path}/login`}>
        <CallbackComponent
          userManager={userManager}
          successCallback={onSigninSuccess}
          errorCallback={onFailure}
        >
          <Container>
            <Title>Track &amp; Trace</Title>
            <Message>Loading...</Message>
          </Container>
        </CallbackComponent>
      </Route>
      <Route exact path={`${match.path}/logout`}>
        <SignoutCallbackComponent
          userManager={userManager}
          successCallback={onSignoutSuccess}
          errorCallback={onFailure}
        >
          <Container>
            <Title>Track &amp; Trace</Title>
            <Message>You are now signed out.</Message>
          </Container>
        </SignoutCallbackComponent>
      </Route>
      <Route exact path={`${match.path}/renew`}>
        {/* This route purposefully left blank - handling done by redux-oidc */}
      </Route>
    </Switch>
  );
};

OidcCallbackHandler.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
    replace: PropTypes.func,
  }).isRequired,
};

export default OidcCallbackHandler;
